export const HEADER_HEIGHT_PX = 60;
export const IMPERSONATION_BANNER_HEIGHT_PX = 50;

const px = (value) => `${value}px`;

export const DEFAULT_FIXED_TOP_OFFSET = px(HEADER_HEIGHT_PX);
export const DEFAULT_IMPERSONATION_BANNER_HEIGHT = px(IMPERSONATION_BANNER_HEIGHT_PX);
export const IMPERSONATION_FIXED_TOP_OFFSET = px(HEADER_HEIGHT_PX + IMPERSONATION_BANNER_HEIGHT_PX);

const resolvedImpersonationBannerHeight = ({
  showImpersonationBanner,
  impersonationBannerHeight,
}) => {
  if (!showImpersonationBanner) return 0;

  return impersonationBannerHeight || IMPERSONATION_BANNER_HEIGHT_PX;
};

export const appImpersonationBannerHeight = ({
  showImpersonationBanner,
  impersonationBannerHeight,
}) => px(resolvedImpersonationBannerHeight({
  showImpersonationBanner,
  impersonationBannerHeight,
}));

export const appFixedTopOffset = ({
  showImpersonationBanner,
  impersonationBannerHeight,
}) => px(HEADER_HEIGHT_PX + resolvedImpersonationBannerHeight({
  showImpersonationBanner,
  impersonationBannerHeight,
}));

export const buildAppShellStyle = ({ showImpersonationBanner, impersonationBannerHeight }) => ({
  '--app-impersonation-banner-height': appImpersonationBannerHeight({
    showImpersonationBanner,
    impersonationBannerHeight,
  }),
  '--app-fixed-top-offset': appFixedTopOffset({ showImpersonationBanner, impersonationBannerHeight }),
});

export const buildAppContentStyle = ({
  user,
  pathname,
  onMobile,
  isImpersonationSetupRoute,
}) => ({
  marginLeft: user !== null
    && !pathname.includes('app/chrome/')
    && !onMobile
    && !isImpersonationSetupRoute
    ? '80px'
    : undefined,
  marginTop: isImpersonationSetupRoute ? '0px' : 'var(--app-fixed-top-offset)',
});
